import lozad from 'lozad';

export default {
  init() {
    // JavaScript to be fired on all pages
    const observer = lozad();
    observer.observe();

    (function ($) {

      $('a[href*=#]').click(function (event) {
        $('html, body').animate({
          scrollTop: $($.attr(this, 'href')).offset().top - 185,
        }, 500);
        event.preventDefault();
      });
      function adjustBannerMargin() {
        if ($('#service-banner').find('.banner-form').length > 0) {
          var bannerFormHeight = $('.banner-form').height();
          bannerFormHeight = bannerFormHeight - 100;
          $('#service-banner').css('margin-bottom', bannerFormHeight + 'px');
        }
      }
      adjustBannerMargin();
      
      $(window).on('resize', adjustBannerMargin);

      // Mobile Nav
      $('#nav-primary-toggle').click(function () {
        $('.nav-primary').toggleClass('open');
        $('.nav-backdrop').toggleClass('show');
      });
      $('.menu-icon').click(function () {
        $(this).toggleClass('open');
      });

      $('#menu-header-menu li.menu-item-has-children').append('<div class="toggle lg:hidden absolute z-20 top-0 right-0 px-2 py-1"><svg class="svg-inline--fa fa-chevron-down fa-w-14" aria-hidden="true" focusable="false" data-prefix="fa" data-icon="chevron-down" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" data-fa-i2svg=""><path fill="currentColor" d="M207.029 381.476L12.686 187.132c-9.373-9.373-9.373-24.569 0-33.941l22.667-22.667c9.357-9.357 24.522-9.375 33.901-.04L224 284.505l154.745-154.021c9.379-9.335 24.544-9.317 33.901.04l22.667 22.667c9.373 9.373 9.373 24.569 0 33.941L240.971 381.476c-9.373 9.372-24.569 9.372-33.942 0z"></path></svg></div>');

      var timing = 200;

      $('#menu-header-menu > li.menu-item-has-children > .toggle').click(function () {
        if ($(this).parent().hasClass('open')) {
          $(this).parent().parent().find('li.menu-item-has-children').removeClass('open');
          $(this).parent().parent().find('.sub-menu').slideUp(timing);
        } else {
          $(this).parent().parent().find('li.menu-item-has-children.open').removeClass('open');
          $(this).parent().parent().find('li.menu-item-has-children.open > .sub-menu').slideUp(timing);
          $(this).parent().toggleClass('open');
          $(this).prev().slideToggle(timing);
        }
      });

      $('#menu-header-menu > li.menu-item-has-children > .sub-menu > li.menu-item-has-children > .toggle').click(function () {
        if ($(this).parent().hasClass('open')) {
          $(this).parent().parent().find('li.menu-item-has-children').removeClass('open');
          $(this).parent().parent().find('.sub-menu').slideUp(timing);
        } else {
          $(this).parent().parent().find('li.menu-item-has-children.open').removeClass('open');
          $(this).parent().parent().find('li.menu-item-has-children.open > .sub-menu').slideUp(timing);
          $(this).parent().toggleClass('open');
          $(this).prev().slideToggle(timing);
        }
      });

      // Desktop nav
      $('#menu-header-menu > li > .sub-menu > li.menu-item-has-children').hover(function () {
        if ($(window).innerWidth() > 991) {
          var target = $(this).find('> ul.sub-menu');
          var width = $(target).outerWidth();

          var right_of_screen = $(window).innerWidth();
          var right_of_parent = $(this).offset().left + $(this).outerWidth();
          var right_of_element = right_of_parent + width;

          if (right_of_screen > right_of_element) {
            $(target).css('transform', 'translateX(100%)');
            $(target).css('right', '0');
          } else {
            $(target).css('transform', 'translateX(-100%)');
            $(target).css('left', '0');
          }
        }
      });

      $('.slick-banner').on('init', function () {
        var hiddenSlides = $('.slick-banner .hidden');
        if (hiddenSlides.length > 1) {
          $('.slick-banner .hidden').each(function (i, el) {
            $(el).removeClass('hidden');
          })
        } else {
          hiddenSlides.removeClass('hidden');
        }
      })

      // Slick
      $('.slick-banner').slick({
        dots: false,
        arrows: false,
        fade: true,
        cssEase: 'ease-in-out',
        slidesToShow: 1,
        slidestoScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1000,
        infinite: true,
      });

      $('.news-slider').slick({
        dots: false,
        arrows: true,
        cssEase: 'ease-in-out',
        slidesToShow: 3.25,
        slidestoScroll: 1,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 1000,
        infinite: false,
        swipeToSlide: true,
        prevArrow: $('.news-arrow.left'),
        nextArrow: $('.news-arrow.right'),
        responsive: [
          {
            breakpoint: 1392,
            settings: {
              slidesToShow: 2.5,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.5,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 1.15,
              slidesToScroll: 1,
            },
          },
        ],
      });

      $('.slick-image-slider').slick({
        dots: false,
        arrows: false,
        fade: true,
        cssEase: 'ease-in-out',
        slidesToShow: 1,
        slidestoScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        speed: 1000,
        infinite: true,
      });

      $('.process-cards-carousel').slick({
        arrows: true,
        cssEase: 'ease-in-out',
        slidesToShow: 3,
        slidestoScroll: 1,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 1000,
        infinite: false,
        prevArrow: $('.process-arrow.left'),
        nextArrow: $('.process-arrow.right'),
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2.5,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1.25,
              slidesToScroll: 1,
            },
          },
        ],
      });
      $('.process-arrow.right').on('click',function(){
        $('.process-cards-carousel').slick('slickNext')
      })
      $('.process-arrow.left').on('click',function(){
        $('.process-cards-carousel').slick('slickPrev')
      })
      // Gallery
      $('.gallery-slider').slick({
        dots: true,
        arrows: false,
        swipeToSlide: true,
        cssEase: 'ease-in-out',
        slidesToShow: 3,
        slidestoScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1000,
        lazyload: 'ondemand',
        infinite: true,
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });

      // Video Carousel
      $('.video-carousel').slick({
        dots: false,
        arrows: true,
        slidesToShow: 1,
        centerMode: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1000,
        prevArrow: $('.carousel-arrow.left'),
        nextArrow: $('.carousel-arrow.right'),
      });

      $('.reviews-video-carousel').slick({
        dots: false,
        arrows: true,
        slidesToShow: 3,
        swipeToSlide: true,
        centerMode: true,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 500,
        prevArrow: $('.reviews-video-arrow.left'),
        nextArrow: $('.reviews-video-arrow.right'),
        responsive: [
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
            },
          },
        ],
      });

      // Slick
      $('.testimonial-slider').slick({
        dots: true,
        arrows: true,
        fade: true,
        cssEase: 'ease-in-out',
        slidesToShow: 1,
        slidestoScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 1000,
        infinite: true,
        prevArrow: $('.testimonial-arrows .left'),
        nextArrow: $('.testimonial-arrows .right'),
      });

      $('.slick-p').click(function () {
        $(this).parent().prev().slick('slickPrev');
      });
      $('.slick-n').click(function () {
        $(this).parent().prev().slick('slickNext');
      });


      $('.video-carousel').on('afterChange', function () {

        $(this).find('video').remove();
        $(this).find('img').show();
        var currentSlide = $(this).find('.slick-current');
        var currentVideoSrc = currentSlide.data('video-src');
        var currentImageSrc = currentSlide.find('img').attr('src');
        var video = currentSlide.find('video');

        if (video.length > 0) {
          null
        } else {
          currentSlide.find('.embed').append('<video class="object-cover" autoplay="" loop="" muted="" poster="' + currentImageSrc + '"> <source src="' + currentVideoSrc + '" type="video/mp4"> Your browser does not support the video tag. </video>');
          currentSlide.find('img').hide();
        }
      });

      $('#review-cta .close').click(function () {
        $(this).parent().hide();
        sessionStorage.setItem('review-cta-close', 'true');
      });
      if (sessionStorage.getItem('review-cta-close')) {
        // $('#review-cta').hide();
      } else {
        $('#review-cta').show();
      }

      // Before & After Tabs

      $('button[name="before-after-tab-toggle"]').click(function () {
        $('button[name="before-after-tab-toggle"]').removeClass('active')
        $(this).addClass('active');
        var target = $(this).data('tab');
        $('.before-after-tab-content').removeClass('active');
        $(target).addClass('active');
      });

      // Alternating Video

      $('.video-overlay').click(function () {
        var video = $(this).next().get(0);

        if ($(this).hasClass('paused')) {
          $(this).removeClass('paused');
          video.play();
          $(this).find('.play-icon').hide();
          $(this).find('.pause-icon').show();
        } else {
          $(this).addClass('paused');
          video.pause();
          $(this).find('.play-icon').show();
          $(this).find('.pause-icon').hide();
        }
      });

      $('.popup-close').on('click', function () {
        $('.popup-global').addClass('closed')
        console.log($('.popup-global'));
      })
      $('#homepage-banner .video-control').click(function () {
        var video = $(this).parent().find('video').get(0);

        if ($(this).hasClass('paused')) {
          $(this).removeClass('paused');
          video.play();
          $(this).find('.play-icon').hide();
          $(this).find('.pause-icon').show();
        } else {
          $(this).addClass('paused');
          video.pause();
          $(this).find('.play-icon').show();
          $(this).find('.pause-icon').hide();
        }

      });

      // Hover images

      $('.hover-image').on('mouseenter', function () {
        var hoverSrc = $(this).data('hover-src');
        var hoverImg = $(this).find('img').attr('src');
        var hoverVideo = $(this).find('video');

        $(this).find('img').hide();

        if (hoverVideo.length > 0) {
          hoverVideo.get(0).currentTime = 0;
          hoverVideo.show();
        } else {
          $(this).find('.embed').append('<video class="object-cover" autoplay="" loop="" muted="" poster="' + hoverImg + '"> <source src="' + hoverSrc + '" type="video/mp4"> Your browser does not support the video tag. </video>');
        }
      });

      $('.hover-image').on('mouseleave', function () {
        var hoverVideo = $(this).find('video');

        if (hoverVideo.length > 0) {
          $(this).find('img').show();
          hoverVideo.hide();
        }
      });

      $('.accordion-item').click(function () {
        $('.accordion-item').removeClass('active');
        $(this).toggleClass('active');
      });


      

      // Share Button
      $('.page-share').click(function () {
        if (navigator.share) {
          navigator.share({
            title: 'Share This Page',
            url: 'https://google.com',
          }).then(() => {
            console.log('Thanks for sharing!');
          })
            .catch(err => {
              console.log('Couldnt share because of', err.message);
            });
        } else {
          $('#panel-share').toggleClass('active');
          console.log('navigator.share not supported!')
        }
      });

      $('.panel-share-close').click(function () {
        $('#panel-share').removeClass('active');
      });
    })(jQuery);
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js